<template>
  <YdDialog :title="title" :visible.sync="showVisible" append-to-body @close="close" width="60%">
    <el-row>
      <el-col>
        <el-form :model="form" :inline="true" size="mini">
          <el-form-item label="手机号">
            <el-input
              clearable
              v-model.trim="form.phone"
              placeholder="请输入用户手机号"
              @keyup.enter.native="search"
            />
          </el-form-item>
          <el-form-item label="标签">
            <yd-label-select v-model="form.tagId" />
          </el-form-item>
          <el-form-item label="会员等级">
            <el-select v-model="form.levelId" clearable>
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in dicOptions.memberLevel"
                :key="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :disabled="loading" @click="search"
              >查询</el-button
            >
            <el-button type="danger" icon="el-icon-delete" :disabled="loading" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <yd-table
      :loading="loading"
      :pagination="pagesOptions"
      :data="tableData"
      row-key="userId"
      @selection-change="tableSelectChange"
      @onChange="onTableChange"
      :settings="{
        showSelect: true
      }"
    >
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        align="center"
        :prop="item.filed"
        :label="item.title"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <yd-link
            v-if="item.filed === 'userId'"
            permi="user_center_manage"
            :value="scope.row.userId"
            :url="`/customer/user/index/${scope.row.phone}/${scope.row.userId}`"
            :need="true"
            type="userInfo"
          />
          <span v-else>{{ scope.row[`${item.filed}`] }}</span>
        </template>
      </el-table-column>
    </yd-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
  </YdDialog>
</template>

<script >
import { defineProps, ref, onMounted, computed, defineExpose } from '@vue/composition-api';
import { useTableList } from '@/hooks';
import { getUserInfoPage } from '@/api/crm/user.js';
import { useCrmDic } from '../hooks/useCrmDic';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '限制参与用户'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    dicOptions
  } = useCrmDic();
  const props = __props;
  const {
    loading,
    tableData,
    pageState,
    searchParam,
    handleCurrentChange,
    handleSizeChange,
    search,
    reset
  } = useTableList(getUserInfoPage, {});
  const tableColumns = [{
    key: 1,
    title: '用户id',
    filed: 'userId',
    width: 180
  }, {
    key: 2,
    title: '手机号',
    filed: 'phone',
    width: 180
  }, {
    key: 6,
    title: '标签',
    filed: 'tags'
  }, {
    key: 4,
    title: '会员等级',
    filed: 'memberLevelName'
  }];
  const pagesOptions = computed(() => ({
    total: pageState.value.total,
    current: pageState.value.currentPage,
    size: pageState.value.pageSize
  }));
  const onTableChange = ({
    type,
    current,
    pageSize
  }) => {
    if (type === 'sizeChange') {
      handleSizeChange(pageSize);
    }
    if (type === 'currentChange' || type === 'fresh') {
      handleCurrentChange(current);
    }
  };
  const emits = __ctx.emit;
  const showVisible = ref(false);
  const form = ref(searchParam);
  onMounted(() => {
    showVisible.value = props.visible;
  });
  const close = () => {
    reset();
    showVisible.value = false;
    emits('close');
  };
  const open = val => {
    showVisible.value = val;
  };
  const selectRowArr = ref([]);
  // 表格选中事件
  const tableSelectChange = selection => {
    selectRowArr.value = [...selection];
  };
  const save = () => {
    emits('userSubmit', selectRowArr.value, 'user');
    selectRowArr.value = [];
    close();
  };
  return Object.assign({
    dicOptions,
    loading,
    tableData,
    search,
    reset,
    tableColumns,
    pagesOptions,
    onTableChange,
    showVisible,
    form,
    close,
    tableSelectChange,
    save
  }, {
    open
  });
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
